module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-3-Media-Whats-the-Influence-6ebb013247ce87d51332bf55d935a694.pdf";